module.exports = __webpack_public_path__ + "media/img/home/gallery/gallery8-b3243c8709c0ec89880712283982523f.png";